import {
  Component,
  inject,
  input,
  InputSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ModalController,
  IonFab,
  IonFabButton,
  IonIcon,
  IonImg,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { PinchZoomComponent } from '../../pinch-zoom/pinch-zoom.component';

/**
 * This component is supposed to be used as a modal.
 * It will display an image when an image URL is passed to this component as
 * an input. The image can be zoomed in for usability purposes.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  imports: [IonFab, IonFabButton, IonIcon, IonImg, PinchZoomComponent],
})
export class ImageModalComponent {
  private readonly modalController: ModalController = inject(ModalController);

  /**
   * The url of the image.
   */
  public readonly imageUrl: InputSignal<string> = input.required<string>();

  constructor() {
    addIcons({ close });
  }

  /**
   * Close the modal.
   */
  public close(): void {
    this.modalController.dismiss();
  }
}
